var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"16","height":"15","fill":"#616161","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.437 8.361l5.42 5.42L7.64 15 .14 7.5 7.64 0l1.218 1.218-5.42 5.42H16v1.723H3.437z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }